import React from "react";

import cx from "classnames";

import styles from "./StarRating.scss";

interface StarProps {
  percentFilled: number;
  hasError: boolean;
}

export function Star({ percentFilled, hasError }: StarProps): JSX.Element {
  const percentFilledStr = `${percentFilled}`;
  const starClassNames = cx(styles["svg"], {
    [styles["error"]]: hasError,
  });
  return (
    <svg
      width="54"
      height="52"
      viewBox="0 0 54 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={starClassNames}
    >
      <defs>
        <linearGradient id={`half_grad-${percentFilledStr}`}>
          <stop offset="0" stopColor="#2A5CDB" />
          <stop offset={percentFilledStr} stopColor="#2A5CDB" />
          <stop offset={percentFilledStr} stopColor="#FFF" />
          <stop offset="1" stopColor="#FFF" />
        </linearGradient>
      </defs>
      <path
        d="M25.5832 2.05597C26.0501 0.712631 27.9499 0.71263 28.4168 2.05597L33.5944 16.9512C33.9377 17.9389 34.8595 18.6086 35.9049 18.6299L51.6711 18.9512C53.093 18.9801 53.68 20.7869 52.5467 21.6462L39.9805 31.1732C39.1472 31.8049 38.7952 32.8885 39.098 33.8893L43.6644 48.9831C44.0762 50.3444 42.5393 51.4611 41.3719 50.6487L28.428 41.6415C27.5697 41.0443 26.4303 41.0443 25.572 41.6415L12.6281 50.6487C11.4607 51.4611 9.92377 50.3444 10.3356 48.9831L14.902 33.8893C15.2048 32.8885 14.8528 31.8049 14.0195 31.1732L1.45327 21.6462C0.319971 20.7869 0.907042 18.9801 2.32893 18.9512L18.0951 18.6299C19.1405 18.6086 20.0623 17.9389 20.4056 16.9512L25.5832 2.05597Z"
        fill={`url(#half_grad-${percentFilledStr})`}
      />
    </svg>
  );
}
